import { GLOBAL_ACCOUNT_CACHE_KEY, type AnalyticsCachedSettings, type MailboxAccountInfoMappingAddon } from "owa-analytics-types";
import type { AccountKey } from "owa-client-types";
import { getAnalyticsAddon } from "owa-analytics-addons";
import { trace } from "owa-trace";

const analyticsCachedSettingsByAccountKey = new Map<string, AnalyticsCachedSettings>();

export function resolveAnalyticsCacheKey(accountKey: AccountKey | "globalAccount" | undefined, scenario: string): string {
    const mailboxMappingAddon = getAnalyticsAddon<MailboxAccountInfoMappingAddon>("MailboxAccountInfoMapping");
    
    if (mailboxMappingAddon.isRegistered) {
        return mailboxMappingAddon.executeNow().getMailboxCacheKey(accountKey, scenario);
    }
    
    trace.warn(`[AnalyticsCacheKey] Missing accountKey for scenario: ${scenario}. Falling back to globalAccount cache key.`, "analytics");
    
    return GLOBAL_ACCOUNT_CACHE_KEY;
}

export function getCachedSettings(accountKey: AccountKey | "globalAccount"): AnalyticsCachedSettings | null {
    const cacheKey = resolveAnalyticsCacheKey(accountKey, "getCachedSettings");
    return analyticsCachedSettingsByAccountKey.get(cacheKey) ?? null;
}

export function setCachedSettings(accountKey: AccountKey | "globalAccount", settings: AnalyticsCachedSettings): void {
    const cacheKey = resolveAnalyticsCacheKey(accountKey, "setCachedSettings");
    analyticsCachedSettingsByAccountKey.set(cacheKey, settings);
}

export function updatePartialCachedSettings(accountKey: AccountKey | "globalAccount", partialSettings: Partial<AnalyticsCachedSettings>): void {
    const cacheKey = resolveAnalyticsCacheKey(accountKey, "updatePartialCachedSettings");
    analyticsCachedSettingsByAccountKey.set(cacheKey, {
        ...analyticsCachedSettingsByAccountKey.get(cacheKey),
        ...partialSettings,
    } as AnalyticsCachedSettings);
}
